import styled from 'styled-components';
import { theme, Text, Row } from '@dls/web';
import { StyledPopover as Popover } from '@/components/Popover/styles';

/* index */
export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  z-index: 1100;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-direction: column;
  font-family: ${theme.main.fontFamily.secondaryRegular};
`;

export const StyledHeaderRow = styled(Row)`
  background-color: #1d3444;
  color: white;
`;

export const HeaderLeft = styled.div`
  border: 0;
  cursor: pointer;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  border-radius: 0;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  background-color: transparent;

  flex: 0 0 auto;
  padding: 12px;
  overflow: visible;
  text-align: center;
  margin-left: -12px;
  margin-right: 16px;
`;

export const HeaderCenter = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

export const HeaderRight = styled(Row)`
  position: relative;
  flex-wrap: nowrap;

  & > div {
    position: relative;
    display: flex;
    flex-grow: unset;
    align-items: center;
    cursor: pointer;
    margin: 0 9px;
    padding: 18px 0px;

    ${Popover} {
      top: 58px;
      visibility: hidden;
    }

    :hover {
      ${Popover} {
        visibility: visible;
      }
    }
  }
`;

export const StyledLogo = styled.img`
  margin-right: 20px;
  height: 40px;
  cursor: pointer;
`;

export const StyledList = styled.ul`
  width: 180px;
  background-color: #1d3444;
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
  position: relative;

  border: 1px solid white;
  border-radius: 2px;

  li {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;

    &:hover {
      background-color: rgb(112, 112, 112);
    }
  }
`;

export const StyledText = styled(Text)`
  color: white;
`;
